import { acceptHMRUpdate, defineStore } from 'pinia';
import { readonly, ref } from 'vue';
import { i18n } from '@/plugins/i18n';
import { fetchDonors, fetchDonorsByReceiverId, Donor } from '@/services/donors';

const { t } = i18n.global;

export type DonorStore = Donor & { address: string };

export const useDonorsStore = defineStore('donors', () => {
  const donors = ref<DonorStore[]>([]);
  const donorsByReceiver = ref<DonorStore[]>([]);
  const showAllDonors = ref(false);
  const isLoading = ref(false);

  const fetchDonorsWithCache = async () => {
    const donorsFromServer = await fetchDonors();

    donors.value = donorsFromServer.map((donor) => {
      const address = !donor.neighborhood || !donor.city ? '' : t('address.default', donor);

      return { ...donor, address };
    });
  };

  const fetchDonorsByReceiver = async (receiverId: string) => {
    isLoading.value = true;

    const donorsFromServer = await fetchDonorsByReceiverId(receiverId);

    isLoading.value = false;

    donorsByReceiver.value = donorsFromServer.map((donor) => {
      const address = !donor.neighborhood || !donor.city ? '' : t('address.default', donor);

      return { ...donor, address };
    });
  };

  return {
    donors: readonly(donors),
    donorsByReceiver: readonly(donorsByReceiver),
    fetchDonorsByReceiver,
    fetchDonorsWithCache,
    isLoading: readonly(isLoading),
    showAllDonors,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDonorsStore, import.meta.hot));
}
